import {
  KeyboardKeyCacheMapModel,
  KeyboardKeys,
  keyboardKeyCacheMapDefaultValues,
} from "./getKeyboardKey.const";

const keyboardKeyCacheMap: KeyboardKeyCacheMapModel = new Map();

export const getKeyboardKey = (event: KeyboardEvent) => {
  const eventKey = event.key;

  if (keyboardKeyCacheMap.has(eventKey)) {
    return (
      keyboardKeyCacheMap.get(eventKey) ?? keyboardKeyCacheMapDefaultValues
    );
  }

  const result = {
    isTabKey: eventKey === KeyboardKeys.TAB,
    isEscKey: [KeyboardKeys.ESCAPE, KeyboardKeys.ESCAPE_SHORT].includes(eventKey as KeyboardKeys),
    isEnterKey: eventKey === KeyboardKeys.ENTER,
    isSpaceKey: eventKey === KeyboardKeys.SPACE,
    isShiftKey: eventKey === KeyboardKeys.SHIFT,
    isArrowLeftKey: eventKey === KeyboardKeys.ARROW_LEFT,
    isArrowRightKey: eventKey === KeyboardKeys.ARROW_RIGHT,
    isArrowUpKey: eventKey === KeyboardKeys.ARROW_UP,
    isArrowDownKey: eventKey === KeyboardKeys.ARROW_DOWN
  };

  keyboardKeyCacheMap.set(eventKey, result);

  return result;
};
